import clsx from 'clsx'
import React, {useCallback, useEffect, useMemo, useState} from 'react'
import {useTranslation} from 'react-i18next'
import useCalendarViewContext from '../../../../context/CalendarView'
import _ from 'lodash'
import {Select} from './Select'
import PopFilterToggle from '../../ShareableView/ShareableViewPopup/Filters/PopFilterToggle'

export const Filters = ({groupView, onChange = (e, v) => {}}) => {
  const {
    displayFields,
    loadDisplayFields,
    sharableEntityObjects,
    sharableEntityFields,
    loadSharableConfiguration,
    sharableFilters,
    setSharableFilters,
    viewData,
    setViewData,
  } = useCalendarViewContext()

  const {t} = useTranslation()
  const {entity_id} = groupView || {}
  const [expand, setExpand] = useState(false)
  const [elRef, setElRef] = useState(null)

  const clearShareableFiltter = useCallback(() => {
    setViewData({
      selectedView: {},
      selectedFilteredViews: [],
      selectedFilterValueFields: [],
    })
    setSharableFilters([])
  }, [setViewData, setSharableFilters])

  const handleCloseValueOption = t => {
    let _selectedFilters = []
    viewData.selectedFilterValueFields.map(sf => {
      if (sf.id !== t.id) {
        _selectedFilters.push(sf)
      }
      return true
    })
    setElRef(null)
    setSharableFilters([..._selectedFilters])
    setViewData({...viewData, selectedFilterValueFields: _selectedFilters})
  }

  useEffect(() => {
    if (!_.isEmpty(groupView) && groupView?.entity_id !== -1) {
      const filtered = []
      const group_id = groupView.entity_id
      _.map(groupView.actions, function getData(val) {
        if (val.active) {
          filtered.push(val.action_id)
        }
      })
      loadDisplayFields(group_id, filtered)
    }
    // eslint-disable-next-line
  }, [groupView.entity_id, groupView?.actions])

  useEffect(() => {
    if (groupView.entity_id && groupView.entity_id !== -1) {
      loadSharableConfiguration(groupView.entity_id)
    }
    clearShareableFiltter()
    // eslint-disable-next-line
  }, [groupView.entity_id])

  const handleClose = (e, v) => {
    setElRef(null)

    const filters = v.map(filter_value => {
      const new_obj = {
        field_id: filter_value.id,
        key: filter_value.key,
        values: filter_value.new_values,
      }
      return new_obj
    })
    onChange(e, filters)
  }

  useEffect(() => {
    const _sharableFilter = []
    groupView?.filters &&
      groupView.filters.map(f => {
        const field = sharableEntityFields.find(option => option.field_id === f.field_id)
        if (field) {
          const value_arr = []
          !_.isEmpty(f.values) && f.values.map(val => value_arr.push(val.id))
          return _sharableFilter.push({
            id: f.field_id,
            field_name: field?.field_name,
            key: f.key,
            value: value_arr,
            values: !_.isEmpty(f.values) && f.values[0],
            new_values: f.values,
          })
        } else {
          return ''
        }
      })
    if (_sharableFilter.length > 0) {
      setSharableFilters(_sharableFilter)
      setViewData({
        ...viewData,
        selectedFilterValueFields: _sharableFilter,
        selectedFilteredViews: [],
      })
    }

    // eslint-disable-next-line
  }, [groupView.filters, setSharableFilters, setViewData, sharableEntityFields])

  return (
    <>
      <div className="ds-flex-col">
        <div>
          <div
            className={clsx('ds-flex-row ds-t080b ds-px-8', {
              'ds-disabled': entity_id === -1,
            })}
            style={{
              alignItems: 'center',
              justifyContent: 'space-between',
              height: 32,
            }}
          >
            <span className="ds-flex-no-spill">
              {t('calendar.filtered-view.add.filters.label')}
            </span>
            <button class="ds-circ-btn ds-circ-btn--fill" onClick={e => setElRef(e.target)}>
              <i class="ds-icon-filter-2"></i>
            </button>
            <i
              class={clsx(
                'ds-ml-6 ds-icon-20x20',
                !expand ? 'ds-icon-caret-right' : 'ds-icon-caret-down'
              )}
              onClick={e => setExpand(p => !p)}
            ></i>
          </div>
          <div
            className={clsx('ds-pl-8 ds-t060r', {
              'ds-disabled': entity_id === -1,
            })}
          >
            {t('calendar.filtered-view.add.filters.description')}
          </div>
        </div>
        <hr className="ds-h-divider ds-mt-8 ds-mb-12" />
        <div className="ds-flex-row" style={{gap: 8, flexWrap: 'wrap'}} hidden={!expand}>
          {viewData?.selectedFilterValueFields?.map(e => {
            return (
              <div class="ds-pill-counter ds-tb600 ds-t080r" style={{display: 'inline-flex'}}>
                {`(${e?.value?.length}) ${e.field_name}`}
                <button
                  class="ds-pill ds-pill--no-border"
                  onClick={() => handleCloseValueOption(e)}
                >
                  <i class="ds-icon-close ds-icon-16x16"></i>
                </button>
              </div>
            )
          })}
        </div>
      </div>

      <PopFilterToggle
        open={!!elRef}
        anchorEl={elRef}
        onClose={handleClose}
        options={sharableEntityFields}
        objects={sharableEntityObjects}
        filters={sharableFilters}
        groupView={groupView}
        setFilterExpand={setExpand}
      />
    </>
  )
}
